import { Link } from 'react-router-dom'
import type { Collection } from '../types'
import { number, short, sol } from '../utils'

export function CollectionTable({ rows }: { rows: Collection[] }) {
  return <div className="table-wrap"><table className="market-table">
    <thead><tr><th>#</th><th>Collection</th><th>Floor</th><th>Volume</th><th>Listed</th><th>Supply</th><th>Royalty</th></tr></thead>
    <tbody>{rows.map((row, index) => <tr key={row.collection_address}>
      <td>{index + 1}</td>
      <td><Link className="collection-cell" to={`/collection/${row.collection_address}`}>
        <span className="collection-thumb">{row.image_url ? <img src={row.image_url} alt=""/> : (row.symbol || 'R').slice(0,1)}</span>
        <span><b>{row.name || short(row.collection_address)}</b><small>{row.symbol || short(row.collection_address)}</small></span>
      </Link></td>
      <td><b>{sol(row.floor_lamports)}</b></td>
      <td>{sol(row.volume_lamports)}</td>
      <td>{number(row.listed_count)}</td>
      <td>{number(row.asset_count)}</td>
      <td>{row.royalty_basis_points != null ? `${(Number(row.royalty_basis_points)/100).toFixed(2)}%` : '—'}</td>
    </tr>)}</tbody>
  </table></div>
}
